import { Divider } from "@mui/material";
import React from "react";
import { NavLink } from "react-router-dom";
import styled from "styled-components";

type NavItemSmallScreenProps = {
  path: string;
  title: string;
  clickHandle?: Function;
};

const NavItemSmallScreen = ({
  path,
  title,
  clickHandle,
}: NavItemSmallScreenProps) => {
  const navClickHandle = () => {
    if (clickHandle) {
      clickHandle();
    }
  };

  return (
    <DivMenuItem>
      <NavLinkSmallScreen to={path} onClick={navClickHandle}>
        {title}
      </NavLinkSmallScreen>
      <DividerSmallScreen />
    </DivMenuItem>
  );
};

const DivMenuItem = styled.div`
  font-size: 1.2rem;
  text-align: left;
  margin-top: 0.5rem;
  margin-left: 0.5rem;
`;

const NavLinkSmallScreen = styled(NavLink)`
  text-decoration: none;
`;

const DividerSmallScreen = styled(Divider)`
  &&& {
    margin-top: 0.5rem;
  }
`;

export default NavItemSmallScreen;
